import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { datadogInit } from "./datadogMetrics";
// import "./App.css"; // Assuming you have some basic styling

// Create a simple redirect page component
const RedirectPage = () => {
  return (
    <div className="redirect-container" style={{ 
      maxWidth: "800px", 
      margin: "100px auto", 
      padding: "40px", 
      textAlign: "center",
      fontFamily: "Arial, sans-serif",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      borderRadius: "8px"
    }}>
      <h1 style={{ fontSize: "28px", marginBottom: "24px" }}>
        Benchmarking Has Moved to Impact Studio
      </h1>
      
      <p style={{ fontSize: "18px", lineHeight: "1.6", marginBottom: "32px" }}>
        The Benchmarking Digital Playbook is now part of Impact Studio, a new and improved platform designed to enhance your reporting experience.
        You can now access all your benchmark reports and insights in one centralized location with a more intuitive interface and expanded capabilities.
      </p>
      
      <hr style={{ margin: "32px 0" }} />
      
      <p style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "16px" }}>
        To continue creating and managing reports, please visit{" "}
        <a 
          href="https://onedigitalrw.my.site.com/ImpactStudio/s/" 
          style={{ color: "#0066cc", textDecoration: "underline" }}
          target="_blank" 
          rel="noopener noreferrer"
        >
          Impact Studio
        </a>
      </p>
    </div>
  );
};

// Simplify router to only show the redirect page
const router = createBrowserRouter([
  {
    path: "*", // Catch all routes
    element: <RedirectPage />
  }
]);

datadogInit();

function App() {
  return <RouterProvider router={router} />;
}

export default App;
